import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths.ts';
import { getInvestmentVehicleQuickLinks } from '@dealstack/frontend/shared/dataExchange/services/mip-manage.service.ts';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { buildQuickLinks } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Investors/InvestorDetailsV2/components/QuickLinksCard/quickLinks.utils.ts';
import { QuickLink } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Investors/InvestorDetailsV2/components/QuickLinksCard/quickLinks.types.ts';

interface Props {
	dealId: string;
	mipId: string;
	personId: string;
}

interface Result {
	links: QuickLink[];
	isLoading: boolean;
	isError: boolean;
}

export const useVehicleQuickLinks = ({ dealId, mipId, personId }: Props): Result => {
	const tMipManage = useTranslationMipManage();

	const quickLinksQuery = useQuery({
		queryKey: [
			API_PATHS.MIP_INVESTOR_INVESTMENT_VEHICLE_PERSONID_QUICK_LINKS_GET,
			{ personId, mipId },
		],
		queryFn: ({ signal }) =>
			getInvestmentVehicleQuickLinks(
				API_PATHS.MIP_INVESTOR_INVESTMENT_VEHICLE_PERSONID_QUICK_LINKS_GET,
				{ personId },
				signal
			),
	});

	const counts = quickLinksQuery.data?.payload;

	const links = useMemo(
		() =>
			buildQuickLinks({
				counts,
				dealId,
				mipId,
				investorIds: counts?.investorIds ?? [],
				tMipManage,
			}),
		[counts, dealId, mipId, tMipManage]
	);

	return {
		links,
		isLoading: quickLinksQuery.isPending,
		isError: quickLinksQuery.isError,
	};
};
